import { render, staticRenderFns } from "./flightSales.vue?vue&type=template&id=e843b6e2&"
import script from "./flightSales.vue?vue&type=script&lang=js&"
export * from "./flightSales.vue?vue&type=script&lang=js&"
import style0 from "./flightSales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports